var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-empty-data"},[_c('p',[_vm._v(_vm._s(_vm.$t("Messages.Empty")))]),(_vm.$route.name === 'menus')?_c('v-btn',{attrs:{"color":"primary","to":{ name: 'menus.create' }}},[_vm._v(" + Add new menu ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }